import { z } from 'zod';
import { Id, TimestampMs } from './common.js';
import { WebAuthnAssertion } from './signing.js';
/**
 * Standing landing grants (docs/e2e.md "Standing landing grants"). `@viko/crypto` land-grant.ts
 * owns the strict statement checks; these schemas are the wire shapes. Plaintext-safe: ids,
 * digests and a passkey assertion only (the target branch is bound by `targetDigest`).
 */
export const LandGrantStatement = z
    .object({
    version: z.literal(1),
    type: z.literal('viko.land-grant'),
    accountId: Id,
    grantId: Id,
    projectId: Id,
    targetDigest: z.string().min(1).max(64),
    policy: z.literal('recipe-must-pass'),
    machineIds: z.array(Id).min(1).max(8),
    deviceKeyId: Id,
    issuedAt: TimestampMs,
    expiresAt: TimestampMs,
})
    .strict();
/** A grant as the client presents it: the statement + the passkey assertion over it. */
export const LandGrantProof = z.object({
    statement: LandGrantStatement,
    assertion: WebAuthnAssertion,
});
/** `GET /api/land-grants` row. */
export const LandGrantRow = z.object({
    id: Id,
    projectId: Id,
    machineIds: z.array(Id),
    deviceKeyId: Id,
    targetDigest: z.string(),
    issuedAt: TimestampMs,
    expiresAt: TimestampMs,
    revokedAt: TimestampMs.nullable(),
    active: z.boolean(),
    proof: LandGrantProof,
});
/**
 * hub → daemon: grants the user revoked (or the emergency stop). Sent on every connect too. A
 * hub can only shrink the set (revocation never adds authority); the daemon persists it.
 */
export const LandGrantRevokedFrame = z.object({
    type: z.literal('land-grant.revoked'),
    grantIds: z.array(Id).max(10_000),
});
//# sourceMappingURL=land-grant.js.map